import { IonContent } from "@ionic/react";
import IframeResizer from "iframe-resizer-react";
import React, { useEffect, useRef, useState } from "react";
import { debug } from "../../../App";
import { ApiService } from "../../../services";
import { AdminTemplate } from "../../PageTemplates";

export const AdminPanel = (props: any) => {
  const [adminUrl, setAdminUrl] = useState<string>("");
  const ionContent = useRef<any>();

  const onMessage = (ev: any) => {
    debug("AdminPanel", "onMessage", ev);

    if (ev.message.action === "setPathname") {
      window.history.pushState({}, "", window.location.pathname + "#" + ev.message.pathname);
    } else if (ev.message.action === "scrollTop") {
      ionContent.current?.scrollToTop();
    }
  };

  useEffect(() => {
    ApiService.getAdminPanelUrl().then((url) => {
      ApiService.getToken().then((token) => {
        setAdminUrl(url + "?api_token=" + token + "&redirectTo=" + encodeURIComponent(window.location.hash.replace("#/", "")));
      });
    });
  }, []);

  return (
    <>
      <AdminTemplate className="page--admin page--admin--settings">
        <IonContent ref={ionContent}>
          {adminUrl ? <IframeResizer frameBorder={0} onMessage={onMessage} title="Admin Area" src={adminUrl} style={{ width: "100%", height: "100%", minHeight: "100%" }} /> : ""}
        </IonContent>
      </AdminTemplate>
    </>
  );
};
